import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { ApiContext } from '../contexts/api-context'
import { BookedSeat, BusinessUnit } from '../types/andTypes'
import { fetchBankHolidays } from '../utilities/fetchBankHolidays'
import { generateNextWorkingDay, isBookedToday } from '../utilities/utils'

const useTodaysSeats = (selectedBU: BusinessUnit | undefined) => {
  const { getSeatBookingOnDate, userProfile, seatBookings } = useContext(ApiContext)

  const [selectedDay, setSelectedDay] = useState<Date>(new Date())
  const [selectedDaysSeats, setSelectedDaysSeats] = useState<BookedSeat[]>([])
  const [isUserBooked, setIsUserBooked] = useState<boolean>(false)
  const [isPublicHoliday, setIsBankHoliday] = useState<boolean>(false)
  const [seletedDaysSeatsForAllBu, setSelectedDaysSeatsForAllBu] = useState<BookedSeat[]>([])

  useEffect(() => {
    async function getRightDay() {
      const day = await generateNextWorkingDay(new Date(), selectedBU?.region)
      setSelectedDay(day)
    }
    getRightDay()
  }, [new Date().getDate()])

  useEffect(() => {
    const bookingsOnDate = getSeatBookingOnDate(selectedDay)
    const todaysSeats = bookingsOnDate?.seats || []
    const buSeatsOnDate = todaysSeats.filter(seat => seat.businessUnit === selectedBU?.id)
    setSelectedDaysSeatsForAllBu(todaysSeats)
    setSelectedDaysSeats(buSeatsOnDate)

    const isPublicHoliday = async () => {
      const bankHolidays = await fetchBankHolidays(selectedBU?.region)
      const date = bankHolidays.find(holiday => dayjs(selectedDay).format('YYYY-MM-DD') === holiday)
      return date !== undefined
    }
    async function setBankholiday() {
      const bankholiday = await isPublicHoliday()
      setIsBankHoliday(bankholiday)
    }
    setBankholiday()

    userProfile && setIsUserBooked(isBookedToday(todaysSeats, userProfile.userId))
  }, [selectedDay, selectedBU?.id, userProfile, seatBookings])

  return {
    isUserBooked,
    selectedDaysSeats,
    seletedDaysSeatsForAllBu,
    selectedDay,
    setSelectedDay,
    isPublicHoliday
  }
}

export default useTodaysSeats
